import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import PRODUCT_DATA from "../data/products";
import { countProducts } from "../utils/helpers";
import { whatsappLink } from "../config/site";
import useDocumentTitle from "../hooks/useDocumentTitle";
import { handleImageError } from "../utils/imageFallback";
import CategoryCard from "../components/CategoryCard";
import ProductCard from "../components/ProductCard";
import "./HomePage.css";

/* ===== HERO IMAGES ===== */
const HERO_IMAGES = [
  "https://i.postimg.cc/zfjKQn7R/Untitled_design_(9).png",
  "https://i.postimg.cc/BvgHzxpD/Untitled_design_(10).png",
  "https://i.postimg.cc/vmzfKWhn/Net_Weight_2_2_kg_Case_Count_6_(2).png",
];

/* ===== BRAND LOGOS ===== */
const BRAND_IMAGES = [
  "https://i.postimg.cc/hGCYVPdy/Go-cheese-Photoroom.png",
  "https://i.postimg.cc/QNKzWDxJ/amul-Photoroom.png",
  "https://i.postimg.cc/4NzFB1cc/mccain-Photoroom.png",
  "https://i.postimg.cc/Cx7rVLmz/dlecta-Photoroom.png",
  "https://i.postimg.cc/hvJVt7nz/41ZCPi_Zt_Zl_L_AC_UF350_350_QL80_removebg_preview.png",
 "https://i.postimg.cc/j2WySJTW/61QDW_u7L7L_AC_UF350_350_QL80_removebg_preview.png",
 
 "https://i.postimg.cc/6q7CpGK8/image_1931_2.avif",
 "https://i.postimg.cc/nrsqhQxB/images_removebg_preview.png",
 "https://i.postimg.cc/J09ZD47n/LKKLogo_square.png",
 "https://i.postimg.cc/QCR19xNC/logo_90x90.webp",
 "https://i.postimg.cc/XqTdG7Np/veeba_logo_main.webp",
 "https://i.postimg.cc/gjf8Xkcr/Venkys.gif",
  "https://i.postimg.cc/hGCYVPdy/Go-cheese-Photoroom.png",
  "https://i.postimg.cc/QNKzWDxJ/amul-Photoroom.png",
  "https://i.postimg.cc/4NzFB1cc/mccain-Photoroom.png",
  "https://i.postimg.cc/Cx7rVLmz/dlecta-Photoroom.png",
  "https://i.postimg.cc/hvJVt7nz/41ZCPi_Zt_Zl_L_AC_UF350_350_QL80_removebg_preview.png",
 "https://i.postimg.cc/j2WySJTW/61QDW_u7L7L_AC_UF350_350_QL80_removebg_preview.png",
 
 "https://i.postimg.cc/6q7CpGK8/image_1931_2.avif",
 "https://i.postimg.cc/nrsqhQxB/images_removebg_preview.png",
 "https://i.postimg.cc/J09ZD47n/LKKLogo_square.png",
 "https://i.postimg.cc/QCR19xNC/logo_90x90.webp",
 "https://i.postimg.cc/XqTdG7Np/veeba_logo_main.webp",
 "https://i.postimg.cc/gjf8Xkcr/Venkys.gif",

];

const FEATURED = [
  {
    name: "Panda Oyster Sauce",
    brand: "LKK",
    size: "2.2kg",
    img: "https://i.postimg.cc/L8X0PtDc/1379acb920b57398ab0e3a696535e08e.png",
  },
 
  {
    name: "Gochujang",
    brand: "Imported",
    size: "500g",
    img: "https://i.postimg.cc/YCsDzvyC/shopping.webp",
  },
  {
    name: "Surecrisp 9mm",
    brand: "M'ccain",
    size: "3kg",
    img: "https://i.postimg.cc/76JYdP9H/b89119b1629a90ef9fd9f3fe6ea16f23.png",
  },
  {
    name: "Mozarella Diced IQF",
    brand: "Go Cheese",
    size: "2kg",
    img: "https://i.postimg.cc/QMWBHzTk/Whats_App_Image_2026_02_19_at_12_39_23_PM_removebg_preview.png",
  },
  {
    name: "Parmesan Cheese ",
    brand: "Grand Gandola",
    size: "4-5kg",
    img: "https://i.postimg.cc/FKtrnHYc/Untitled-design-(2).png",
  },
  {
    name: "Cream Cheese ",
    brand: "Dlecta",
    size: "1kg",
    img: "https://i.postimg.cc/cJg6fJf9/Cream-Cheese-Front.png",
  },
  {
    name: "Instant Dry Yeast ",
    brand: "Blue Vallley",
    size: "500g",
    img: "https://i.postimg.cc/cLzVFfns/shopping.webp",
  },
  {
    name: "Hot Kitchen Frozen Cream ",
    brand: "Rich",
    size: "1L",
    img: "https://i.postimg.cc/xjkfgP1V/RCRHK_Front.webp",
  },
  {
    name: "Prawns",
    brand: "Safako",
    size: "1kg",
    img: "https://i.postimg.cc/13rtKnLJ/Whats_App_Image_2026_03_06_at_11_42_03_PM.jpg",
  },
  {
    name: "Vietnamese Basa",
    brand: "Safako",
    size: "2.5kg",
    img: "https://i.postimg.cc/vZtBvgp0/Whats_App_Image_2026_03_06_at_11_42_59_PM.jpg",
  },
  {
    name: "⁠Hot & Crispy Wings",
    brand: "Assorted Brands",
    size: "1kg",
    img: "https://i.postimg.cc/JnFTshKM/d9f4ec00834b6b4faed2c8db2bbfc85b.png",
  },
  {
    name: "White Truffle Oil",
    brand: "Urbani",
    size: "250ml",
    img: "https://i.postimg.cc/wjvbNX2Z/40326734_1_urbani_white_truffle_oil.webp",
  },
  {
    name: "Gelatin",
    brand: "Assorted",
    size: "25g",
    img: "https://i.postimg.cc/3NJHGn26/40205932-2-puramate-veg-gelatin.webp",
  },
  

];

export default function HomePage() {

  const categories = Object.entries(PRODUCT_DATA);

  const totalProducts = categories.reduce(
    (acc, [, data]) => acc + countProducts(data.subcategories),
    0
  );

  useDocumentTitle();

  /* HERO SLIDE */
  const [heroIndex, setHeroIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setHeroIndex(prev => (prev + 1) % HERO_IMAGES.length);
    }, 5000);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      {/* ================= HERO ================= */}

      <div className="hero">
        <div className="hero-main hero-with-slider">

          {/* IMAGE SLIDER */}
          <div className="hero-slider">
            <div
              className="hero-slider-track"
              style={{ transform: `translateX(-${heroIndex * 100}%)` }}
            >
              {HERO_IMAGES.map((img, i) => (
                <img key={i} src={img} alt="" onError={handleImageError} />
              ))}
            </div>
          </div>

          {/* CONTENT */}
          <div className="hero-content">

            <div className="hero-tag">🏷️ Wholesale Distributor</div>

            <h1 className="hero-title">
              “Reliable Wholesale Supply for HoReCa Businesses" 
              <br />
              <span>In Jharkhand</span>
            </h1>

            <p className="hero-desc">
              Your one-stop wholesale partner for cheese, dairy, frozen foods,
              sauces, beverages and more.
            </p>

            <div className="hero-actions">

              <a
                className="hero-cta"
                href={whatsappLink("Hi Sai Concept, I would like to place a wholesale order.")}
                target="_blank"
                rel="noopener noreferrer"
              >
                Order On Whatsapp
              </a>

              <Link to="/about" className="hero-about-btn">
                About Us
              </Link>

            </div>

          </div>

        </div>
      </div>

      {/* ================= BRAND TICKER ================= */}

      <div className="brand-ticker">
        <div className="brand-track">
          {[...BRAND_IMAGES, ...BRAND_IMAGES].map((img, i) => (
            <div className="brand-item" key={i}>
              <img src={img} alt="" loading="lazy" decoding="async" onError={handleImageError} />
            </div>
          ))}
        </div>
      </div>

      {/* ================= CATEGORIES ================= */}

      <section className="section">
        <div className="section-header">
          <h2 className="section-title">Browse Categories</h2>
          <span className="section-count">{totalProducts} products</span>
        </div>

        <div className="categories-grid">
          {categories.map(([name, data], i) => (
            <CategoryCard key={name} name={name} data={data} index={i} />
          ))}
        </div>
      </section>

      {/* ================= FEATURED ================= */}

      <section className="section">
        <h2 className="section-title">Featured Products</h2>

        <div className="products-grid">
          {FEATURED.map((product, i) => (
            <ProductCard key={i} product={product} index={i} />
          ))}
        </div>
      </section>

    </>
  );
}
